import { SET_GET_USER_INFO, SET_IS_EMAIL_REGISTER } from '../constants';

const initialState = {
  getUserInfo: '',
  isEmailRegister: false,
};

export const userSuspendedInfo = (state = initialState, action) => {
  switch (action.type) {
    case SET_GET_USER_INFO:
      return {
        getUserInfo: action.payload,
      };
    case SET_IS_EMAIL_REGISTER:
      return {
        ...state,
        isEmailRegister: action.payload,
      };
    default:
      return state;
  }
};

export default userSuspendedInfo;
